import React from "react";
import { BeatLoader } from "react-spinners";
import { FileResponse } from "../../types/FileResponse";
import { Box, useMediaQuery } from "@mui/material";
import Record from '../../assets/record.png';

type CoverDisplayProps = {
    cover: FileResponse | undefined;
};

const CoverDisplay = ({ cover }: CoverDisplayProps) => {
    const isLessThan500 = useMediaQuery('(max-width:580px)');
    const isLessThan1000 = useMediaQuery('(max-width:1000px)');
    
    return (
        <Box
            sx={{
                width: isLessThan500 ? '100%' : isLessThan1000 ? '500px' : '600px',
                height: isLessThan500 ? '100%' : '500px',
                textAlign: 'center',
            }}
        >
            <>
                {cover?.fileContents === undefined
                    ?
                    <BeatLoader
                        loading={cover?.fileContents === undefined}
                        size={24}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    :
                    <>
                        <Box
                            component="img"
                            alt={'Album Cover'}
                            sx={{
                                width: isLessThan500 ? '100%' : '500px',
                                height: isLessThan500 ? '100%' : '500px',
                            }}
                            src={`data:image/jpeg;base64,${cover?.fileContents}`}
                        />
                        {!isLessThan1000 && <Box component="img" src={Record} />}
                    </>
                }
            </>
        </Box>
    );
};

export default CoverDisplay;